import React from 'react';

import { SmartCaptcha } from '@yandex/smart-captcha';
import { useTranslation } from 'react-i18next';

import { ICaptchaComponentProps, TYandexCaptchaLangs } from '@entities/captcha/model/types';

export const YandexCaptcha = ({ setToken }: ICaptchaComponentProps) => {
    const { i18n } = useTranslation();

    const captchaLanguage: TYandexCaptchaLangs = i18n.language as TYandexCaptchaLangs;

    const handleSuccess = (token: string) => {
        setToken(token);
    };
    const handleTokenExpired = () => {
        setToken('');
    };

    return (
        <SmartCaptcha
            sitekey={ENV.REACT_APP_YANDEX_CAPTCHA_SITE_KEY}
            onSuccess={handleSuccess}
            onTokenExpired={handleTokenExpired}
            language={captchaLanguage}
        />
    );
};
